import moment from 'moment';

export default class RTV {
  constructor({
    id,
    index = 0,
    rtvDate,
    rtvNumber,
    articleCode,
    articleDescription,
    vendorCode,
    rtvQuantity,
    rtvValue,
    isVerified,
    physicalQuantity,
    currentStatus,
    dateOfPickUp,
    rtvDocumentUrl,
    passoutSlipUrl,
    courierPodUrl,
    dateOfDispatch,
    storeid,
    submittedBy,
    submittedByName,
    storeName
  }) {
    this.id = id || '';
    this.articleCode = articleCode || '';
    this.articleDescription = articleDescription || '';
    this.vendorCode = vendorCode || '';
    this.rtvDate = rtvDate ? moment(rtvDate).format('DD-MM-YYYY') : null;
    this.rtvNumber = rtvNumber || '';
    this.rtvQuantity = rtvQuantity || '';
    this.rtvValue = rtvValue || '';
    this.isVerified = isVerified || false;
    this.physicalQuantity = physicalQuantity || '';
    this.currentStatus = currentStatus || '';
    this.dateOfDispatch = dateOfDispatch ? moment(dateOfDispatch).format('DD-MM-YYYY') : null;
    this.dateOfPickUp = dateOfPickUp ? moment(dateOfPickUp).format('DD-MM-YYYY') : null;
    this.rtvDocumentUrl = rtvDocumentUrl || '';
    this.passoutSlipUrl = passoutSlipUrl || '';
    this.courierPodUrl = courierPodUrl || '';
    this.storeid = storeid || '';
    this.submittedBy = submittedBy || '';
    this.submittedByName = submittedByName || '';
    this.storeName = storeName || '';
    this.index = index;
  }
}
